<template>
  <VDropdown
    placement="bottom-start"
    :aria-id="ariaId"
    @apply-show="isFocusLoopActive = true"
    @apply-hide="isFocusLoopActive = false"
    class="inline-flex"
  >
    <button
      class="inline-flex items-center rounded-full px-3 py-2 font-semibold text-neutral-900 transition-colors hover:bg-neutral-50 focus:outline-none focus-visible:ring focus-visible:ring-neutral-200"
    >
      <slot name="icon" />
      {{ name }}
      <ChevronRightIcon
        class="ml-2 w-2 shrink-0 transition-transform"
        :class="[isFocusLoopActive ? 'rotate-270' : 'rotate-90']"
      />
    </button>
    <template #popper>
      <div
        class="w-48 overflow-x-hidden overflow-y-hidden rounded-lg shadow-md"
      >
        <FocusLoop
          :is-active="isFocusLoopActive"
          :auto-focus="false"
          is-arrows-navigation-active
        >
          <div class="flex flex-col">
            <InertiaLink
              v-for="(item, index) in items"
              :key="index"
              :href="item.href[accessControl.role]"
              class="inline-flex items-center px-5 py-3 text-sm text-neutral-700 transition-colors hover:bg-neutral-50 hover:text-current focus:bg-neutral-100 focus:outline-none"
            >
              <component :is="item.icon" class="mr-4 size-4" />
              {{ item.name }}
            </InertiaLink>
          </div>
        </FocusLoop>
      </div>
    </template>
  </VDropdown>
</template>

<script setup>
import FocusLoop from '../FocusLoop.vue'
import ChevronRightIcon from '~icons/lucide/chevron-right'
import { ref, useId } from 'vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem'

defineProps({
  name: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    default: '',
  },
  items: {
    type: Array,
    default: () => [],
  },
})

const { accessControl } = usePermissionSystem()

const ariaId = useId()
const isFocusLoopActive = ref(false)
</script>
